/**
 * toastのtype 背景色を切り替える
 */
const ToastType = {
  // テキスト中央のtoast
  INFORMATION: 'info',
  // テキスト左寄せのtoast
  INFORMATION_LEFT: 'info-left',
  // 背景エラー色、テキスト中央のtoast
  ERROR: 'error'
};
export { ToastType as default };
